<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :wrapperClosable="false"
    append-to-body
    title="计费信息维护"
    :visible="detailShow"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div slot="title" class="dialog-header-title">
      <span class="name">计费信息维护</span>
    </div>
    <div class="form_content" style="padding: 20px">
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-row class="form_head_title"> 租户信息 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="记录编号:" prop="maintain_no">
              <el-input v-model="formData.maintain_no" disabled placeholder="保存后自动生成"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称:" prop="customer_name">
              <el-input v-model="formData.customer_name" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号:" prop="order_no">
              <el-input v-model="formData.order_no" disabled style="width: 70%"></el-input>
              <a @click="orderRecord(formData.refId)" v-if="formData.order_no" class="detailBtn"> 查看详情 </a>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款单号:" prop="payment_no">
              <el-input v-model="formData.payment_no" disabled style="width: 70%"></el-input>
              <a @click="paymentRecord(formData.payment_id, formData.order_status)" v-if="formData.payment_no" class="detailBtn"> 查看详情 </a>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称" prop="account_name">
              <el-input v-model="formData.account_name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目前状态:" prop="current_state">
              <el-select v-model="formData.current_state" placeholder="请选择" style="width: 100%" disabled>
                <el-option v-for="item in cellStatusList" :key="item.index" :label="item.name" :value="String(item.code)"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="套餐名称:" prop="contacts_package">
              <el-input v-model="formData.contacts_package" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title"> 维护内容 </el-row>
        <el-row>
          <el-col :span="12" v-if="formData.account_key != 8">
            <el-form-item label="开通时间:" prop="open_time">
              <el-date-picker style="width: 100%" v-model="formData.open_time" value-format="yyyy-MM-dd" disabled placeholder="选择日期"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.account_key != 10 && formData.account_key != 8">
            <el-form-item label="费用到期时间:" prop="expire_time">
              <el-date-picker style="width: 100%" v-model="formData.expire_time" value-format="yyyy-MM-dd" disabled placeholder="选择日期"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="购买用户数:" prop="users_number" v-if="data.account_key == 1 || data.account_key == 8">
              <el-input-number disabled :precision="0" v-model="formData.users_number" :min="0" :max="9999999999"></el-input-number>
            </el-form-item>
            <el-form-item
              label="本次充值次数:"
              prop="purchases_number"
              v-if="formData.account_key == 3 || formData.account_key == 10 || formData.account_key == 8"
            >
              <el-input-number :precision="0" disabled v-model="formData.purchases_number" :min="-9999999999" :max="9999999999"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="formData.account_key == 3 || formData.account_key == 10 || formData.account_key == 8">
          <el-col :span="12">
            <el-form-item label="累计充值次数:" prop="total_number" style="position: relative">
              <span class="tips">(包含本次充值次数)</span>
              <el-input-number :precision="0" v-model="formData.total_number" :min="0" :max="9999999999" disabled></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="累计已使用:" prop="total_use" v-if="formData.account_key == 3 || formData.account_key == 10 || formData.account_key == 8">
              <el-input-number :precision="0" v-model="formData.total_use" :min="0" :max="9999999999" disabled></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注:" prop="remark">
          <el-input v-model="formData.remark" maxlength="3000" show-word-limit disabled autosize type="textarea"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="编制人:" prop="create_user">
              {{ formData.create_user }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编制时间:" prop="create_time">
              {{ formData.create_time }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 订单详情 -->
    <order-record :show="showOrderRecord" :orderId="orderId" @closeOrderRecord="closeOrderRecord"> </order-record>
    <!-- 付款记录 -->
    <payment-record :show="showPaymentRecord" :paymentId="paymentId" :isCancle="isCancle" @closePaymentRecord="closePaymentRecord"> </payment-record>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import * as constants from '../billingCenter/constants'
import moment from 'moment'
import PaymentRecord from '../billingCenter/paymentRecord.vue'
import OrderRecord from '../billingCenter/orderRecord.vue'
export default {
  components: {
    PaymentRecord,
    OrderRecord
  },
  data() {
    return {
      isCancle: false,
      drawerSize: '70%',
      showPaymentRecord: false,
      paymentId: '',
      showOrderRecord: false,
      orderId: '',
      detailShow: false,
      formData: {
        maintain_no: '',
        customer_name: '',
        customer_id: '',
        account_key: '',
        account_name: '',
        current_state: 0,
        contacts_package: '',
        open_time: '',
        expire_time: '',
        users_number: 0,
        purchases_number: 0,
        total_use: 0,
        total_number: 0,
        remark: '',
        create_user: '',
        create_time: ''
      },
      data: {},
      rules: {
        open_time: [
          {
            required: true,
            message: '请选择开通时间',
            trigger: ['blur', 'change']
          }
        ],
        expire_time: [
          {
            required: true,
            message: '请选择费用到期时间',
            trigger: ['blur', 'change']
          }
        ],
        users_number: [
          {
            required: true,
            message: '请输入购买用户数',
            trigger: ['blur', 'change']
          }
        ],
        purchases_number: [
          {
            required: true,
            message: '请输入本次充值次数',
            trigger: ['blur', 'change']
          }
        ],
        remark: [
          {
            required: false,
            max: 3000,
            message: '字数不得超过3000',
            trigger: ['blur', 'change']
          }
        ]
      },
      ...constants,
      accountList: []
    }
  },
  props: ['show', 'detailId'],
  watch: {
    show: {
      handler(newVal, oldVal) {
        this.detailShow = newVal
      },
      deep: true,
      immediate: true
    },
    detailId: {
      handler(newVal, oldVal) {
        if (newVal) this.getDetail(newVal)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    //订单付款记录关闭
    closePaymentRecord() {
      this.showPaymentRecord = false
    },
    //订单付款记录
    paymentRecord(id, status) {
      this.isCancle = false
      this.paymentId = ''
      if (id) {
        this.paymentId = id
      }
      if (status == '3') {
        this.isCancle = true
      }
      this.showPaymentRecord = true
    },
    //订单详情关闭
    closeOrderRecord() {
      this.showOrderRecord = false
    },
    //订单详情
    orderRecord(id) {
      this.orderId = ''
      if (id) {
        this.orderId = id
      }
      this.showOrderRecord = true
    },
    // 获取详情
    getDetail(id) {
      this.$http.get('${third}/costcenter/third_maintain/' + id).then((res) => {
        if (res.data) {
          res.data.create_time = res.data.createTime
          res.data.create_user = res.data.createByName
          this.formData = res.data
        }
      })
    },

    //关闭dialog
    beforeCloseDialog() {
      this.detailShow = false
      this.$emit('closeDetailDialog')
    },
    //客户选择器同时绑定客户id
    customerChange(val) {
      this.accountList.forEach((item) => {
        if (item.name == val) {
          this.formData.customer_id = item.code
        }
      })
    },
    //产品名称数据绑定
    accountChange(val) {
      this.productList.forEach((item) => {
        if (item.name == val) {
          this.formData.account_key = item.code
        }
      })
    },
    //提交数据
    submit() {
      this.$refs.ruleForm.validate((valid) => {
        this.$set(this.formData, 'refId', this.refId)
        if (valid) {
          this.$http.post('${third}/costcenter/third_maintain/', this.formData).then((res) => {
            if (res.data.state) {
              this.$message.success('保存成功！')
              this.$emit('closeDetailDialog', true)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.tips {
  color: rgba(199, 199, 199, 100);
  font-size: 12px;
  position: absolute;
  left: -110px;
  top: 16px;
}
.detailBtn {
  color: #377cff;
  cursor: pointer;
}
</style>
